import React from "react";
import { TypeAnimation } from "react-type-animation";

const ComingSoon = () => {
  return (
    <div>
      <div className="flex justify-center mt-20 mb-20 text-3xl font-bold dark:text-slate-100 px-2 py-20 rounded-full type-animation-fix">
        <TypeAnimation
          sequence={[
            // Same substring at the start will only be typed out once, initially
            "Coming soon",
            1000, // wait 1s before replacing "Mice" with "Hamsters"
            "Coming next",
            1000,
            "Coming fast",
            1000,
          ]}
          wrapper="span"
          speed={50}
          style={{ fontSize: "1em", display: "inline-block", backgroundColor: "transparent" }}
          repeat={Infinity}
        />
      </div>
    </div>
  );
};

export default ComingSoon;
